export type Language = 'PL' | 'EN'

export enum PERMISSIONS {
  REPLENISHMENT = 'replenishmentVisibility',
  DATA_SOURCE = 'dataSourceVisibility',
  GENERAL_RESULTS = 'generalResultsVisibility',
  DISTRICT_RESULTS = 'districtResultsVisibility',
  REGION_RESULTS = 'regionResultsVisibility',
  ALERTS = 'alertsVisibility',
  RANGES = 'rangesVisibility',
  MARGIN = 'marginVisibility',
  COMPLETENESS = 'completenessVisibility',
  RANKINGS_COMPANIES_STATIONARY = 'rankingsCompaniesStationaryVisibility',
  RANKINGS_COMPANIES_BY_CHANNELS = 'rankingsCompaniesByChannelsVisibility',
  RANKINGS_COMPANIES_ECOMMERCE = 'rankingsCompaniesEcommerceVisibility',
  RANKINGS_COMPANIES_CLUB_CARD = 'rankingsCompaniesClubCardVisibility',
  RANKINGS_WEBSITE_ECOMMERCE = 'rankingsWebsiteEcommerceVisibility',
  RANKINGS_BEST20_SHOPS = 'rankingsBest20ShopsVisibility',
  RANKINGS_WORST20_SHOPS = 'rankingsWorst20ShopsVisibility',
  RANKINGS_DISTRICT = 'rankingsDistrictVisibility',
  RANKINGS_RKSVISIBILITY = 'rankingsRKSVisibility',
  RANKINGS_STORES_OPEN_WITHIN30_DAYS = 'rankingsStoresOpenWithin30DaysVisibility',
  RANKINGS_STORES_OPEN_WITHIN12_MONTHS = 'rankingsStoresOpenWithin12MonthsVisibility',
}

export interface VisibilitySettings {
  [PERMISSIONS.REPLENISHMENT]?: boolean
  [PERMISSIONS.DATA_SOURCE]?: boolean
  [PERMISSIONS.GENERAL_RESULTS]?: boolean
  [PERMISSIONS.DISTRICT_RESULTS]?: boolean
  [PERMISSIONS.REGION_RESULTS]?: boolean
  [PERMISSIONS.ALERTS]?: boolean
  [PERMISSIONS.RANGES]?: boolean
  [PERMISSIONS.MARGIN]?: boolean
  [PERMISSIONS.COMPLETENESS]?: boolean
  [PERMISSIONS.RANKINGS_COMPANIES_STATIONARY]?: boolean
  [PERMISSIONS.RANKINGS_COMPANIES_BY_CHANNELS]?: boolean
  [PERMISSIONS.RANKINGS_COMPANIES_ECOMMERCE]?: boolean
  [PERMISSIONS.RANKINGS_COMPANIES_CLUB_CARD]?: boolean
  [PERMISSIONS.RANKINGS_WEBSITE_ECOMMERCE]?: boolean
  [PERMISSIONS.RANKINGS_BEST20_SHOPS]?: boolean
  [PERMISSIONS.RANKINGS_WORST20_SHOPS]?: boolean
  [PERMISSIONS.RANKINGS_DISTRICT]?: boolean
  [PERMISSIONS.RANKINGS_RKSVISIBILITY]?: boolean
  [PERMISSIONS.RANKINGS_STORES_OPEN_WITHIN30_DAYS]?: boolean
  [PERMISSIONS.RANKINGS_STORES_OPEN_WITHIN12_MONTHS]?: boolean
}

export interface Settings extends VisibilitySettings {
  behalfOfUserName: string | null
  dataViewType?: number
  language?: Language
  useLocalCurrency?: boolean
}

export interface User {
  settings: Settings
}
